import React, { Component } from 'react';

var config = process.env;

const TIPOS = [
    ['RETIRO', 'Retiro'],
    ['GASTO', 'Gasto pagado del cajón'],
    ['INGRESO', 'Ingreso'],
    ['AJUSTE_FONDO', 'Ajuste de fondo'],
];

const SALIDAS = ['RETIRO', 'GASTO'];

/**
 * Movimientos de caja del turno (docs/spec-caja.md, F3).
 *
 * Reemplaza el campo agregado "Retiros" del cierre, que era un número suelto sin motivo, sin hora
 * y sin autor — con eso se podía constatar un faltante pero no explicarlo. Acá cada movimiento
 * queda con su razón y quién lo hizo, y se refleja en el esperado del cierre en el momento.
 */
class CashMovementsPanel extends Component {

    state = { tipo: 'RETIRO', monto: '', motivo: '', quien: '', enviando: false, error: null };

    money = (n) => `$${Number(n || 0).toLocaleString('de-DE')}`;

    // 24 h y sin "p. m.": en dos dígitos entra en la columna sin envolverse.
    hora = (iso) => {
        try {
            return new Intl.DateTimeFormat('es-UY', {
                hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
            }).format(new Date(iso));
        } catch (e) {
            return '';
        }
    };

    registrar = () => {
        if (this.state.monto === '' || this.state.enviando) {
            return;
        }
        // El nombre, aparte de la cuenta: el login del local es compartido, así que sin esto un
        // retiro no tiene dueño.
        if (this.state.quien.trim().length < 2) {
            this.setState({ error: 'Poné quién registra el movimiento.' });
            return;
        }

        this.setState({ enviando: true, error: null });

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'cashSession/movements', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
            body: JSON.stringify({
                type: this.state.tipo,
                amount: this.state.monto,
                reason: this.state.motivo,
                created_by_name: this.state.quien.trim(),
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data && data.error === 0) {
                    // El nombre se conserva: durante el turno lo registra casi siempre la misma persona.
                    this.setState({ monto: '', motivo: '', enviando: false });
                    if (this.props.onChange) this.props.onChange();
                    return;
                }
                this.setState({ enviando: false, error: (data && data.message) || 'No se pudo registrar el movimiento.' });
            })
            .catch(() => this.setState({ enviando: false, error: 'No se pudo registrar el movimiento.' }));
    };

    render() {
        const { movements } = this.props;

        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                    <span>Movimientos del turno</span>
                    <small className="text-muted">Entran en el arqueo al cerrar</small>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-3 mb-2">
                            <select className="form-control form-control-sm" value={this.state.tipo}
                                onChange={(e) => this.setState({ tipo: e.target.value })}>
                                {TIPOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                            </select>
                        </div>
                        <div className="col-md-2 mb-2">
                            <input type="text" className="form-control form-control-sm" placeholder="$0"
                                value={this.state.monto}
                                onChange={(e) => this.setState({ monto: e.target.value.replace(/[^\d.]/g, '') })} />
                        </div>
                        <div className="col-md-3 mb-2">
                            <input type="text" className="form-control form-control-sm" placeholder="Motivo"
                                value={this.state.motivo}
                                onChange={(e) => this.setState({ motivo: e.target.value })} />
                        </div>
                        <div className="col-md-2 mb-2">
                            <input type="text" className="form-control form-control-sm" placeholder="Quién" maxLength={60}
                                value={this.state.quien}
                                onChange={(e) => this.setState({ quien: e.target.value, error: null })} />
                        </div>
                        <div className="col-md-2 mb-2">
                            <button className="btn btn-sm btn-primary btn-block" onClick={this.registrar}
                                disabled={this.state.monto === '' || this.state.enviando}>
                                Registrar
                            </button>
                        </div>
                    </div>

                    {this.state.error && (
                        <div className="alert alert-danger py-2 mb-2" style={{ fontSize: 13 }}>{this.state.error}</div>
                    )}

                    {(!movements || movements.length === 0) ? (
                        <small className="text-muted">Todavía no hay movimientos en este turno.</small>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
                                <thead>
                                    <tr>
                                        {['Hora', 'Tipo', 'Motivo', 'Quién', 'Monto'].map((h, i) => (
                                            <th
                                                key={h}
                                                style={{
                                                    textAlign: i === 4 ? 'right' : 'left',
                                                    padding: '0 12px 6px 0',
                                                    borderBottom: '1px solid #c3ccd4',
                                                    fontSize: 10.5,
                                                    letterSpacing: '.08em',
                                                    textTransform: 'uppercase',
                                                    color: '#77838f',
                                                    fontWeight: 600,
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {movements.map((m) => {
                                        const sale = SALIDAS.includes(m.type);
                                        const etiqueta = (TIPOS.find(([v]) => v === m.type) || [null, m.type])[1];
                                        const celda = { padding: '7px 12px 7px 0', borderBottom: '1px solid #eceff1' };
                                        return (
                                            <tr key={m.id}>
                                                <td style={{ ...celda, whiteSpace: 'nowrap', color: '#77838f', width: 1 }}>
                                                    {this.hora(m.created_at)}
                                                </td>
                                                <td style={{ ...celda, whiteSpace: 'nowrap' }}>{etiqueta}</td>
                                                <td style={{ ...celda, color: '#6b7680' }}>{m.reason || '—'}</td>
                                                <td style={{ ...celda, whiteSpace: 'nowrap' }}>
                                                    {m.created_by_name || m.created_by}
                                                </td>
                                                <td style={{
                                                    ...celda,
                                                    paddingRight: 0,
                                                    textAlign: 'right',
                                                    whiteSpace: 'nowrap',
                                                    fontVariantNumeric: 'tabular-nums',
                                                    fontWeight: 500,
                                                    color: sale ? '#a8402f' : '#2c7a5a',
                                                }}>
                                                    {sale ? '−' : '+'}{this.money(m.amount)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default CashMovementsPanel;
